import { GrnStatusEnum } from "apps/services/procurement-service/src/app/grn/dto/grn-status.enum";

export class GrnDtos{
    status?: GrnStatusEnum; 
    reasonId?: number;
    quantity?: number; 

constructor(
    status?: GrnStatusEnum,
    reasonId?: number,
    quantity?: number,
){
    this.status=status
    this.quantity=quantity;
    this.reasonId=reasonId;

}
}



